import React from "react"
import ProfilePic from "../assets/image/demo.jpg"
import { Link } from "gatsby"
import moment from "moment"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"

// const info = require("../assets/data/blogsContent.json")
function Card(props) {
  return (
    // <div style={{ display: "inline-block" }}>
    <Link to={`/blogs/${props.url}`} style={{ display: "inline-block" }}>
      <div className="border border-gray-300 p-1 rounded-lg blog-box sm:mx-4 my-3 sm:m-6 hover:shadow-xl relative ">
        <div className="border-bottom bg-orange-light1 absolute top-full left-6 right-6 h-1.5 rounded-b-xl"></div>
        <div className="blog-img-container">
          <img src={props.img} className="w-full" />
        </div>
        <div className="px-3 pt-4">
          <p className="text-md blue-dark1 font-semibold mt-4 box-title">
            {props.catgory}
          </p>
          <p className="text-md blue-dark1 font-semibold my-4 box-title">
            {props.title}
          </p>
          <p className="text text-sm box-text my-4"> <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.description}</ReactMarkdown></p>
        </div>
        <div className="flex items-center my-3 px-3 text-sm">
          <img
            src={props.author_thumbnail}
            className="rounded-full h-12 w-12"
          />
          <div className="flex flex-col sm:flex-row items-center">
            <p className="font-semibold mx-6">{props.author_name}</p>
            <p>{moment(props.published).format("DD MMM Y")}</p>
          </div>
        </div>
      </div>
    </Link>
    // </div>
  )
}

export default Card
